module.exports = __webpack_public_path__ + "static/media/virtual_games.a9205b5a.svg";